import { apiClient as api } from "./httpClient";

export interface TaxRateItem {
  id: string;
  name: string;
  ratePercent: number;
  active: boolean;
}

export interface TaxRegimeItem {
  id: string;
  entityId: string;
  regime: string;
  active: boolean;
  startDate: string;
  endDate?: string;
  totalPercent: number;
  rates: TaxRateItem[];
}

export interface CreateTaxRegimePayload {
  entityId: string;
  regime: string;
  startDate: string; // yyyy-MM-dd — início da vigência (RN-206a)
  endDate?: string; // opcional: em branco = vigente; períodos não podem se cruzar
  rates: Array<{ name: string; ratePercent: number }>;
}

export const REGIME_OPTIONS = [
  "Simples Nacional",
  "Micro Empreendedor Individual",
  "Micro Empreendedor",
  "Lucro Presumido",
];

export const entityTaxRegimeService = {
  getByEntity: async (entityId: string): Promise<TaxRegimeItem[]> => {
    const response = await api.get(`/entity-tax-regimes/by-entity/${entityId}`);
    return Array.isArray(response.data) ? response.data : [];
  },
  create: async (payload: CreateTaxRegimePayload): Promise<void> => {
    await api.post("/entity-tax-regimes", payload);
  },
  // Encerra a vigência com a data de corte (inclusive) — pré-requisito para novo regime
  deactivate: async (id: string, endDate: string): Promise<void> => {
    await api.patch(`/entity-tax-regimes/${id}/deactivate`, { endDate });
  },
  // Edita a vigência; o servidor recusa datas que cruzem outro regime
  updatePeriod: async (
    id: string,
    startDate: string,
    endDate?: string
  ): Promise<void> => {
    await api.put(`/entity-tax-regimes/${id}/period`, { startDate, endDate });
  },
};
